var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };} /* eslint-disable max-lines */
import React, { useState } from 'react';

import { useFetcher, useLoaderData } from 'react-router-dom';


import { Translate } from "../../../../I18N";
import { Button, ConfirmationModal, Table, Tabs } from "../../../Components/UI";
import * as usersAPI from "../../../api/users";
import { SettingsContent } from "../../../Components/Layouts/SettingsContent";
import {
  UserFormSidepanel,
  GroupFormSidepanel,
  getUsersColumns,
  getGroupsColumns,
  ListOfItems } from "./components";

import { useHandleNotifications } from "./useHandleNotifications";




// eslint-disable-next-line max-statements
const Users = () => {
  const { users, groups } =
  useLoaderData() || [];

  const [activeTab, setActiveTab] = useState('Users');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [sidepanelData, setSidepanelData] = useState(

  );
  const [showSidepanel, setShowSidepanel] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [confirmationModalProps, setConfirmationModalProps] = useState({
    header: 'Delete',
    body: 'Do you want to delete?'
  });
  const [bulkActionIntent, setBulkActionIntent] = useState('delete-users');

  const fetcher = useFetcher();

  useHandleNotifications();

  const usersTableColumns = getUsersColumns((user) => {
    setShowSidepanel(true);
    setSidepanelData(user);
  });

  const groupsTableColumns = getGroupsColumns((group) => {
    setShowSidepanel(true);
    setSidepanelData(group);
  });

  const handleBulkAction = () => {
    const formData = new FormData();
    formData.set('intent', bulkActionIntent);

    if (activeTab === 'Users') {
      formData.set('data', JSON.stringify(selectedUsers.map((user) => user.original)));
    } else {
      formData.set('data', JSON.stringify(selectedGroups.map((group) => group.original)));
    }

    fetcher.submit(formData, { method: 'post' });
  };

  return /*#__PURE__*/(
    _jsx("div", { className: "tw-content", style: { width: '100%', overflowY: 'auto' } }, void 0, /*#__PURE__*/
    _jsx(SettingsContent, {}, void 0, /*#__PURE__*/
    _jsx(SettingsContent.Header, { title: "Users & Groups" }), /*#__PURE__*/

    _jsx(SettingsContent.Body, {}, void 0, /*#__PURE__*/
    _jsx(Tabs, {
      onTabSelected: (tab) => {
        setActiveTab(tab);
        setSelectedUsers([]);
        setSelectedGroups([]);
        setSidepanelData(undefined);
      } }, void 0, /*#__PURE__*/

    _jsx(Tabs.Tab, { id: "Users", label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Users") }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: usersTableColumns,
      data: users,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Users"),
      enableSelection: true,
      onSelection: setSelectedUsers,
      initialState: { sorting: [{ id: 'username', desc: false }] } }
    )
    ), /*#__PURE__*/

    _jsx(Tabs.Tab, { id: "Groups", label: /*#__PURE__*/_jsx(Translate, {}, void 0, "Groups") }, void 0, /*#__PURE__*/
    _jsx(Table, {
      columns: groupsTableColumns,
      data: groups,
      title: /*#__PURE__*/_jsx(Translate, {}, void 0, "Groups"),
      enableSelection: true,
      onSelection: setSelectedGroups,
      initialState: { sorting: [{ id: 'name', desc: false }] } }
    )
    )
    )
    ), /*#__PURE__*/

    _jsx(SettingsContent.Footer, {}, void 0, /*#__PURE__*/
    _jsx("div", { className: "flex gap-2" }, void 0,
    selectedUsers.length ? /*#__PURE__*/
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx(Button, {
      styling: "light",
      onClick: () => {
        setConfirmationModalProps({
          header: 'Reset passwords',
          body: 'Do you want reset the password for the following users?'
        });
        setBulkActionIntent('bulk-reset-password');
        setShowConfirmationModal(true);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Reset Password")
    ), /*#__PURE__*/

    _jsx(Button, {
      styling: "light",
      onClick: () => {
        setConfirmationModalProps({
          header: 'Reset 2FA',
          body: 'Do you want disable 2FA for the following users?'
        });
        setBulkActionIntent('bulk-reset-2fa');
        setShowConfirmationModal(true);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Reset 2FA")
    )
    ) :
    undefined,

    selectedUsers.length || selectedGroups.length ? /*#__PURE__*/
    _jsx(Button, {
      color: "error",
      onClick: () => {
        setConfirmationModalProps({
          header: 'Delete',
          body: 'Do you want to delete the following items?'
        });
        setBulkActionIntent(activeTab === 'Users' ? 'delete-users' : 'delete-groups');
        setShowConfirmationModal(true);
      } }, void 0, /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Delete")
    ) :
    undefined,

    !selectedUsers.length && !selectedGroups.length ? /*#__PURE__*/
    _jsx(Button, {
      onClick: () => {
        setSidepanelData(undefined);
        setShowSidepanel(true);
      } }, void 0,

    activeTab === 'Users' ? /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Add user") : /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add group")

    ) :
    undefined
    )
    )
    ),

    activeTab === 'Users' ? /*#__PURE__*/
    _jsx(UserFormSidepanel, {
      selectedUser: sidepanelData,
      showSidepanel: showSidepanel,
      setShowSidepanel: setShowSidepanel,
      setSelected: setSidepanelData,
      users: users,
      groups: groups }
    ) : /*#__PURE__*/

    _jsx(GroupFormSidepanel, {
      selectedGroup: sidepanelData,
      showSidepanel: showSidepanel,
      setShowSidepanel: setShowSidepanel,
      setSelected: setSidepanelData,
      users: users,
      groups: groups }
    ),


    showConfirmationModal && /*#__PURE__*/
    _jsx(ConfirmationModal, {
      header: confirmationModalProps.header,
      warningText: confirmationModalProps.body,
      body: /*#__PURE__*/_jsx(ListOfItems, { items: selectedUsers.length ? selectedUsers : selectedGroups }),
      onAcceptClick: () => {
        handleBulkAction();
        setShowConfirmationModal(false);
        setSelectedGroups([]);
        setSelectedUsers([]);
      },
      onCancelClick: () => setShowConfirmationModal(false),
      dangerStyle: true }
    )

    ));

};

const usersLoader =
(headers) =>
async () => {
  const users = await usersAPI.get(headers);
  const groups = await usersAPI.getUserGroups(headers);
  return { users, groups };
};

const userAction =
() =>
async ({ request }) => {
  const formData = await request.formData();
  const formIntent = formData.get('intent');

  const formValues = JSON.parse(formData.get('data'));

  switch (formIntent) {
    case 'new-user':
      return usersAPI.newUser(formValues);
    case 'edit-user':
      return usersAPI.updateUser(formValues);
    case 'delete-users':
      return usersAPI.deleteUser(formValues);
    case 'new-group':
    case 'edit-group':
      return usersAPI.saveGroup(formValues);
    case 'delete-groups':
      return usersAPI.deleteGroup(formValues);
    case 'unlock-user':
      return usersAPI.unlockAccount(formValues);
    case 'reset-password':
    case 'bulk-reset-password':
      return usersAPI.resetPassword(formValues);
    case 'reset-2fa':
    case 'bulk-reset-2fa':
      return usersAPI.reset2FA(formValues);
    default:
      return null;
  }
};

export { Users, usersLoader, userAction };